import { useState } from 'preact/hooks';

import { authStore } from '../../global-store/subjects/auth';

import { useSubscribe } from './use-subscribe';

const SESSION_LOGIN_CARD = 'sessionLoginCard_';

const getSessionLoginCard = (widgetId) => sessionStorage.getItem(SESSION_LOGIN_CARD + widgetId);
const setSessionLoginCard = (widgetId) => sessionStorage.setItem(SESSION_LOGIN_CARD + widgetId, true);

export const useLoginCard = (widgetId) => {
  const authState = useSubscribe(authStore);
  const sessionLoginCardExists = Boolean(getSessionLoginCard(widgetId));
  const defaultIsVisible = !sessionLoginCardExists && !authState.isUserLogged;
  const [isVisible, setIsVisible] = useState(defaultIsVisible);

  const handleLoginCardClose = () => {
    setIsVisible(false);
    setSessionLoginCard(widgetId);
  };

  const toggleLoginCardVisibility = () => {
    setIsVisible(!sessionLoginCardExists && !authState.isUserLogged);
  };

  return [isVisible, toggleLoginCardVisibility, handleLoginCardClose];
};
